import script from "./DistributionIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributionIndex.vue?vue&type=script&setup=true&lang=js"

import "./DistributionIndex.vue?vue&type=style&index=0&id=18a15330&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a15330"]])

export default __exports__